import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography, TableRow, TableCell, Grid, Skeleton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { COLORS } from "src/_globalStore/redux/reducers/Theme/themeConstants";
import { StyledTable, Container } from "./styles";
import { EmployeeDocumentsSummaryDTO } from "../../../../models/employee-documents-summary/employee-documents-summary-dto";
import { EmployeeDocumentsSummaryApiService } from "../../../../services/employees/employee-documents-summary-api.service";

interface State {
  error: string;
  loading: boolean;
  summary: EmployeeDocumentsSummaryDTO | null;
}
const MyDocumentsLink = () => {
  const tRP = "components.custom_widget_links.my_documents";
  const { t } = useTranslation();
  const theme = useTheme();
  const [state, setState] = useState<State>({
    error: "",
    loading: false,
    summary: null,
  });
  const getCustomSummary = async (signal?: AbortSignal) => {
    setState((state) => ({
      ...state,
      loading: true,
    }));
    try {
      const response = await new EmployeeDocumentsSummaryApiService().loadItems();

      if (!signal?.aborted) {
        if (!response.error) {
          setState((state) => ({
            ...state,
            summary: response.items[0],
          }));
        } else {
          setState((state) => ({
            ...state,
            error: response.error,
          }));
        }
      }
    } catch (error) {
      !signal?.aborted &&
        setState((state) => ({
          ...state,
          error: error as string,
        }));
    } finally {
      !signal?.aborted &&
        setState((state) => ({
          ...state,
          loading: false,
        }));
    }
  };

  useEffect(() => {
    const abortController = new AbortController();

    getCustomSummary(abortController.signal);

    return () => abortController.abort();
  }, []);

  return (
    <Container>
      <StyledTable>
        <tbody>
          <TableRow>
            <TableCell>
              <Typography>{`${t(`${tRP}.payslips`)}`}</Typography>
            </TableCell>
            <TableCell align="left">
              {state.loading ? (
                <Skeleton
                  variant="rounded"
                  width={"70%"}
                />
              ) : (
                <React.Fragment>
                  <hr
                    style={{
                      margin: "0",
                      backgroundColor: theme.palette.warning.main,
                      width: `${
                        state.summary?.payslips
                          ? state.summary?.payslips < 30
                            ? (state.summary?.payslips / 30) * 70
                            : 70
                          : 1
                      }%`,
                    }}
                  />
                  <Typography>
                    {`${
                      state.summary?.payslips
                        ? Number(state.summary?.payslips) > 30
                          ? "30+"
                          : state.summary?.payslips
                        : "0"
                    }`}
                  </Typography>{" "}
                </React.Fragment>
              )}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <Typography>{`${t(`${tRP}.timesheets`)}`}</Typography>
            </TableCell>
            <TableCell align="left">
              {state.loading ? (
                <Skeleton
                  variant="rounded"
                  width={"70%"}
                />
              ) : (
                <React.Fragment>
                  <hr
                    style={{
                      margin: "0",
                      backgroundColor: COLORS.yellow_gradients.yellow,
                      width: `${
                        state.summary?.timesheets
                          ? state.summary?.timesheets < 30
                            ? (state.summary?.timesheets / 30) * 70
                            : 70
                          : 1
                      }%`,
                    }}
                  />
                  <Typography>{`${
                    state.summary?.timesheets
                      ? Number(state.summary?.timesheets) > 30
                        ? "30+"
                        : state.summary?.timesheets
                      : "0"
                  }`}</Typography>
                </React.Fragment>
              )}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <Typography>{`${t(`${tRP}.contracts`)}`}</Typography>
            </TableCell>
            <TableCell align="left">
              {state.loading ? (
                <Skeleton
                  variant="rounded"
                  width={"70%"}
                />
              ) : (
                <React.Fragment>
                  <hr
                    style={{
                      margin: "0",
                      backgroundColor: theme.palette.primary.light,
                      width: `${
                        state.summary?.timesheets
                          ? state.summary?.contracts < 30
                            ? (state.summary?.contracts / 30) * 70
                            : 70
                          : 1
                      }%`,
                    }}
                  />
                  <Typography>{`${
                    state.summary?.contracts
                      ? Number(state.summary?.contracts) > 30
                        ? "30+"
                        : state.summary?.contracts
                      : "0"
                  }`}</Typography>
                </React.Fragment>
              )}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <Typography>{`${t(`${tRP}.ids`)}`}</Typography>
            </TableCell>
            <TableCell align="left">
              {state.loading ? (
                <Skeleton
                  variant="rounded"
                  width={"70%"}
                />
              ) : (
                <React.Fragment>
                  <hr
                    style={{
                      margin: "0",
                      backgroundColor: theme.palette.success.main,
                      width: `${
                        state.summary?.ids ? (state.summary?.ids < 30 ? (state.summary?.ids / 30) * 70 : 70) : 1
                      }%`,
                    }}
                  />
                  <Typography>{`${
                    state.summary?.ids ? (Number(state.summary?.ids) > 30 ? "30+" : state.summary?.ids) : "0"
                  }`}</Typography>
                </React.Fragment>
              )}
            </TableCell>
          </TableRow>
        </tbody>
      </StyledTable>
      {Number(state.summary?.missingDocuments) > 0 ? (
        <Grid
          style={{
            color: theme.palette.error.main,
            display: "flex",
            alignItems: "center",
          }}
        >
          <FontAwesomeIcon icon={faExclamationCircle} />
          <Typography>{`${t(`${tRP}.missing_documents`)}`}</Typography>
        </Grid>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default MyDocumentsLink;
